import { Component, OnInit } from '@angular/core'
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { ApiService } from '../api.service'
import { UserService } from '../user.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
    menu
    menuOpen = false
    subMenu = false

    constructor(
        private apiService: ApiService,
        private userService: UserService,
    ) {}

    ngOnInit() {
        if ( this.userService.isAuthorized ) {
            this.getMenu()
        }
    }

    getMenu() {
        this.apiService.getMenu().subscribe(
            (data) => {
                this.menu = data
            },
            (error) => {
                console.log(`menu unavailable`)
            }
        );
    }

    menuToggle = () => {
        this.menuOpen = !this.menuOpen;
    }

    subMenuOpen = () => {
        this.subMenu = !this.subMenu;
    }
}
